<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="父级菜单:" prop="parentId">
          <Select
            v-model="formFields.parentId"
            clearable
            filterable
            placeholder="请选择父级菜单..."
            size="small"
          >
            <Option v-for="menu in rootMenus" :key="menu.id" :value="menu.id" :label="menu.label" />
          </Select>
        </FormItem>
        <FormItem label="菜单名称:" prop="label">
          <Input v-model="formFields.label" placeholder="请输入菜单名称..." size="small" />
        </FormItem>
        <FormItem label="模块名称:" prop="module">
          <Input v-model="formFields.module" placeholder="请输入模块名称..." size="small" />
        </FormItem>
        <FormItem label="资源路径:" prop="path">
          <Input v-model="formFields.path" placeholder="请输入资源路径URL..." size="small" />
        </FormItem>
        <FormItem label="菜单图标:" prop="icon">
          <Input v-model="formFields.icon" placeholder="请输入菜单图标样式名..." size="small" />
        </FormItem>
        <!-- <FormItem label="路由标识名:" prop="name">
          <Input v-model="formFields.name" placeholder="请输入菜单标识..." size="small" />
        </FormItem> -->
        <FormItem label="菜单描述:" prop="description">
          <Input v-model="formFields.description" placeholder="请输入菜单描述..." size="small" />
        </FormItem>
        <FormItem label="排列序号:" prop="sort">
          <Input v-model="formFields.sort" placeholder="请输入菜单排列序号..." size="small" />
        </FormItem>
        <FormItem label="是否可见:" prop="status">
          <RadioGroup v-model="formFields.status">
            <Radio :label="1" :true-value="1">
              可见
            </Radio>
            <Radio :label="0" :true-value="0">
              隐藏
            </Radio>
          </RadioGroup>
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { getRouterNameByPath } from '@/utils/util'
export default {
  name: 'MenuFormDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      rootMenus: [],
      formFields: {
        parentId: '',
        name: '',
        icon: '',
        module: '',
        path: '',
        status: 1,
        sort: 1,
        id: this.id,
        label: '',
        description: ''
      }
    }
  },
  computed: {
    ruleValidate() {
      return {
        // name: [{ required: this.hasPath, message: '路由标识名不能为空!', trigger: 'blur' }],
        label: [{ required: true, message: '菜单名称不能为空!', trigger: 'blur' }],
        path: [{ required: this.isParentMenu, message: '菜单路径不能为空!', trigger: 'blur' }]
      }
    },
    isParentMenu() {
      return this.formFields.parentId && this.formFields.parentId !== ''
    },
    hasPath() {
      return this.formFields.path !== ''
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑菜单' : '添加新菜单'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      this.loadRootMenus()
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          this.formFields = res.data
        }).catch(error => {
          this.loadingStatus = false
          console.log(error)
        })
      }
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
    },
    async loadRootMenus() {
      const _that = this
      await request({
        url: this.$config.apiContextPath + '/menu/root',
        method: 'get'
      }).then(res => {
        _that.rootMenus = res.data
      }).catch(error => {
        console.log(error)
        _that.rootMenus = []
      })
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.action) {
            this.$refs.form.validate((valid) => {
              if (valid) {
                this.submit = true
                const isNew = this.formFields.id === 0
                const routerName = getRouterNameByPath(this.formFields.path)
                if (!routerName) {
                  this.submit = false
                  this.loadingStatus = false
                  this.$Notice.error({
                    title: '数据输入有误',
                    desc: '资源路径 `' + this.formFields.path + '` 不识别!'
                  })
                } else {
                  this.formFields.name = routerName.toUpperCase()
                  request({
                    url: this.action + (isNew ? '' : ('/' + this.id)),
                    method: isNew ? 'POST' : 'PUT',
                    data: this.formFields
                  }).then(res => {
                    this.loadingStatus = false
                    this.formFields = res.data
                    this.$Notice.success({
                      title: '菜单 `' + this.formFields.name + '` 保存成功!'
                    })
                    this.submit = false
                    this.closeModal(true)
                  }).catch(error => {
                  // this.$Notice.error({
                  //   title: '服务器数据请求失败',
                  //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
                  // })
                    this.loadingStatus = false
                    this.submit = false
                    console.log(error)
                  })
                }
              }
            })
          }
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

